<template>
  <div class="navbar">
    <div class="container">
      <div class="small-nav-menu" v-on:click="toggleSidebar">
        <img src="../assets/images/menu-icon.svg" class="menu-icon" alt="Navigation Menu" />
      </div>

      <!-- <div class="profile-nav">
        <div class="profile-item">
          Brandyn Traxinger
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',

  data () {
    return {

    }
  },

  methods: {
    toggleSidebar: function () {
      this.$parent.forceSidebarVisible = !this.$parent.forceSidebarVisible
    }
  }
}
</script>

<style scoped>
  .container {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .menu-icon {
    height: 30px;
    opacity: .8;
  }

  .navbar {
    min-height: 3.5em;
    padding: 1em 1em 1em 2em;
    position: absolute;
    z-index: 998;
    right: 0;
  }

  .nav-item {
    border-left: 1px solid var(--navbar-text);
    cursor: pointer;
    flex-direction: row;
    padding: .5em 1em .5em 1em;
    text-transform: uppercase;
  }

  .nav-item:hover {
    border: none;
    margin-left: 1px;
    outline: 3px solid var(--navbar-text);
  }

  .nav-item:active {
    background: var(--navbar-text);
    color: white;
  }

  .profile-item {
    flex-direction: row;
    padding: .5em 1em;
    text-transform: uppercase;
  }

  .profile-nav {
    color: var(--navbar-text);
    display: flex;
    flex-basis: auto;
    justify-content: flex-end;
  }

  @media only screen and (max-width: 991px) {
    .profile-nav {
      display: none;
    }
  }

  .small-nav-menu {
    align-items: center;
    color: white;
    display: inline-flex;
    visibility: hidden;
  }

  @media only screen and (max-width: 991px) {
    .small-nav-menu {
      visibility: visible;
    }
  }
</style>
